<template>
  <div>
    <div class="container headerCon">
      <img src="../assets/logo.png" alt="" class="logo">
      <nav style="margin-top: 10px;">
        <ul>
          <router-link to="/">
            <li @click="headerItemClick(1)" :class="headerAction == 1 ? 'actionLi' : ''">网站首页</li>
          </router-link>
          <router-link to="/product?id=1">
            <li @click="headerItemClick(2)" :class="headerAction == 2 ? 'actionLi' : ''">公司新闻</li>
          </router-link>
          <router-link to="/product?id=18">
            <li @click="headerItemClick(3)" :class="headerAction == 3 ? 'actionLi' : ''">公司产品</li>
          </router-link>
          <router-link to="/product?id=7">
            <li @click="headerItemClick(4)" :class="headerAction == 4 ? 'actionLi' : ''">解决方案</li>
          </router-link>
          <router-link to="/product?id=19">
            <li @click="headerItemClick(5)" :class="headerAction == 5 ? 'actionLi' : ''">成功案例</li>
          </router-link>
          <router-link to="/product?id=21">
            <li @click="headerItemClick(6)" :class="headerAction == 6 ? 'actionLi' : ''">公共服务平台</li>
          </router-link>
          <router-link to="/AboutUs">
            <li @click="headerItemClick(7)" :class="headerAction == 7 ? 'actionLi' : ''">关于我们</li>
          </router-link>
          <!--<a href="http://8.130.23.129:8000/login">后台管理页面</a>-->
        </ul>
      </nav>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        headerAction: 1,
      };
    },
    mounted() {

    },
    methods: {
      headerItemClick(val) {
        this.headerAction = val;
      },
    },
  };
</script>

<style>
  @import url('../assets/css/hearder.css');
</style>



// WEBPACK FOOTER //
// src/components/hearder.vue